import React from 'react';
import styled from 'styled-components';

const Banner = styled.div`
  width: 100%;
  max-width: ${(props) => props.$maxWidth || '900px'};
  margin: 0 auto 1rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  background: rgba(251, 191, 36, 0.12);
  border: 1px solid rgba(251, 191, 36, 0.35);
  color: #fde68a;
  font-size: 0.92rem;
  line-height: 1.5;
`;

const StorageBlockedNotice = ({ maxWidth }) => (
  <Banner $maxWidth={maxWidth} role="alert">
    <strong>Storage blocked.</strong> Your browser is not saving quiz results locally (private mode, strict settings, or
    storage full). You can still take the quiz, but results may not persist. Allow site storage or use a normal browser
    window to keep your report.
  </Banner>
);

export default StorageBlockedNotice;
